import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import { Popover, PopoverSurface, PopoverTrigger, Button, mergeClasses } from '@fluentui/react-components';
import PropTypes from 'prop-types';
import { useViewAllFiltersButtonStyle } from './styles';

export const FilterListWithPopover = ({
  filters, onClickFilter, i18n,
}) => {
  const classes = useViewAllFiltersButtonStyle();

  return (
    <div className="view-content-popover">
      <div className={classes.viewContentTitle}>{i18n.getString('Filters')}</div>
      {_.map(filters, filter =>
      (
        <Button
          key={`filter-${filter.id}`}
          className={classNames('filter-item', classes.viewAllFilterItem)}
          onClick={() => onClickFilter(filter)}
        >
          <span>{`${i18n.getString(filter.title)}: ${filter.humanizedValue}`}</span>
        </Button>
      ))}
    </div>
  );
};

FilterListWithPopover.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    humanizedValue: PropTypes.string,
  })).isRequired,
  onClickFilter: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};


const ViewAllFiltersButtonImpl = ({
  filters, onClickFilter, i18n,
}) => {
  const classes = useViewAllFiltersButtonStyle();
  // don't show the always visible filters on the View all popover
  const selectedFilters = _.filter(filters, ({ isFilterAlwaysVisible }) => !isFilterAlwaysVisible);
  return (_.isEmpty(selectedFilters) ? null : (
    <Popover withArrow positioning={{ position: 'after', align: 'start' }}>
      <PopoverTrigger>
        <Button as="a" className={mergeClasses('view-all-button', classes.viewAllButton)}>{i18n.getString(_TL_('View all'))}</Button>
      </PopoverTrigger>

      <PopoverSurface>
        <FilterListWithPopover i18n={i18n} onClickFilter={onClickFilter} filters={selectedFilters} />
      </PopoverSurface>
    </Popover>
  ));
};

ViewAllFiltersButtonImpl.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    isFilterAlwaysVisible: PropTypes.bool,
  })).isRequired,
  onClickFilter: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const ViewAllFiltersButton = React.memo(ViewAllFiltersButtonImpl);
